import React from 'react';

const ThemeContext = React.createContext({
  // Any theme related props needed? Put them in here
});

export default ThemeContext;
